import { FlagsMenu, TopHeader as Header } from "@mindsight/einstein";
import { Button, Menu } from "antd";
import { useCallback, useEffect, useState } from "react";

import { PoweroffOutlined } from "@ant-design/icons";
import { Loader } from "semantic-ui-react";
import controleLogo from "/controleLogo.png";
import controleNewLogo from "../../../imgs/svgs/controleLogo.svg";
import { useAuth } from "../../../utils/Auth";
import { useSettings } from "../../../utils/Settings";
import { to } from "../../../utils/Url";
import { useEnableSankhyaMenu } from "../../../utils/useEnableSankhyaMenu";
import { useHideLogoutSankhyaRh } from "../../../utils/useHideLogoutSankhyaRH";
import { useNewDesign } from "../../../utils/useNewDesign";
import { MindsightAuthSystemApi } from "../../Api";
import { ErrorSegment } from "../ErrorSegment";
import { SideMenuButton } from "../SideMenuButton";
import { TopHeaderContainer } from "./styles";

const userMenu = (user, hideLogoutSankhyaRh) => {
  return (
    <Menu className="header-avatar-menu">
      <Menu.Item key="infs" style={{ textAlign: "center" }}>
        <b style={{ color: "#166889" }}>
          {user?.email || user?.username || "-"}
        </b>
      </Menu.Item>
      {user?.first_name && (
        <Menu.Item key="name">
          <p style={{ color: "#737380" }}>
            {user?.first_name} {user?.last_name}
          </p>
        </Menu.Item>
      )}
      {!hideLogoutSankhyaRh && (
        <Menu.Item key="sair">
          <Button
            icon={<PoweroffOutlined />}
            style={{ width: "100%", textAlign: "center" }}
            href={to("/accounts/logout/")}
          >
            Sair
          </Button>
        </Menu.Item>
      )}
    </Menu>
  );
};

export const TopHeader = () => {
  const { user } = useAuth();
  const { data: settings, isFetching: isPending, error } = useSettings();
  const [systemName, setSystemName] = useState("Organograma");
  const buttonToggle = settings
    ? settings.find((setting) => setting.key === "SHOULD_SHOW_SIDE_MENU")
        ?.value === "True"
    : false;
  const sideMenuUrl = settings
    ? settings.find((setting) => setting.key === "REACT_APP_AUTH_DOMAIN")?.value
    : null;

  const { enableSankhyaMenu } = useEnableSankhyaMenu(sideMenuUrl);

  const getSystemName = useCallback(async () => {
    const currentDomain = window.location.host;
    if (sideMenuUrl && !sideMenuUrl.includes(currentDomain)) {
      const response = await MindsightAuthSystemApi.getSystemName(sideMenuUrl);
      setSystemName(response.name);
    }
  }, [sideMenuUrl]);

  const { isNewDesignActive, isLoading } = useNewDesign(sideMenuUrl);
  const { hideLogoutSankhyaRh, isLoading: isLoadingHideLogoutSankhyaRh } =
    useHideLogoutSankhyaRh(sideMenuUrl);

  useEffect(() => {
    getSystemName();
  }, [getSystemName]);

  if (isPending) return <Loader active data-testid="top-menu-loader" />;
  if (error) return <ErrorSegment message={error.message} />;

  const getNameInitials = () => {
    if (user?.first_name) {
      const nameArray = user?.first_name.split(" ");
      if (nameArray.length >= 2) {
        return nameArray[0][0] + nameArray[1][0];
      }
      return nameArray[0][0];
    }

    return "";
  };

  if (isLoading || isLoadingHideLogoutSankhyaRh) return null;

  return (
    <TopHeaderContainer>
      <Header
        systemHomeUrl="/"
        systemName={systemName}
        logoImgSrc={isNewDesignActive ? controleNewLogo : controleLogo}
        sideMenuButton={
          buttonToggle && !enableSankhyaMenu ? (
            <SideMenuButton currentUrl={sideMenuUrl} />
          ) : null
        }
        avatarName={getNameInitials()}
        userMenu={userMenu(user, hideLogoutSankhyaRh)}
        flagsMenu={
          <FlagsMenu currentLanguage={"pt-br"} languages={["pt-br"]} />
        }
      />
    </TopHeaderContainer>
  );
};
